import { render } from "./CoinRsiModal.vue?vue&type=template&id=24e8d134&scoped=true"
import script from "./CoinRsiModal.vue?vue&type=script&lang=js"
export * from "./CoinRsiModal.vue?vue&type=script&lang=js"

import "./CoinRsiModal.vue?vue&type=style&index=0&id=24e8d134&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e8d134"]])

export default __exports__